import { ExpressionKinds } from "../../../../../../documaker/domain/format/objects";
import { ICalculateObject } from "../../../../../domain/editableFormat/objects";
import { ICalculateObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { CalculatableObjectTranslator } from "./base";
import {
  NumberStyleTranslator,
  NumberRangeAlertBehaviorTranslator,
  DecimalRoundBehaviorTranslator,
  ExpressionBehaviorTranslator,
  RelationReplacer,
} from "./properties";

export class CalculateObjectTranslator extends AbstractObjectTranslator<ICalculateObject, ICalculateObjectBean> {
  constructor() {
    super(new CalculatableObjectTranslator());
  }

  protected shouldRecordName(source: ICalculateObjectBean): boolean {
    return true;
  }

  overwriteObject(source: ICalculateObject, bean: ICalculateObjectBean, formatId: number): void {
    source.expressionKind = this.integer.from(bean["@form-type"]);
    source.expressionBehavior = this.expressionBehavior.from(bean);
    source.numberStyle = this.numberStyle.from(bean);
    source.numberRangeAlertBehavior = this.numberRangeAlertBehavior.from(bean);
    source.decimalRoundBehavior = this.decimalRoundBehavior.from(bean);
  }

  overwriteBean(source: ICalculateObjectBean, object: ICalculateObject): void {
    source["@type"] = "1";
    source["@form-type"] = this.integer.to(object.expressionKind);
    source["@text-format"] = this.numberStyle.to(object).textFormat;
    const numberRangeAlertBehavior = this.numberRangeAlertBehavior.to(object);
    source["@high-value"] = numberRangeAlertBehavior.highValue;
    source["@high-over-color"] = numberRangeAlertBehavior.highOverColor;
    source["@low-value"] = numberRangeAlertBehavior.lowValue;
    source["@low-over-color"] = numberRangeAlertBehavior.lowOverColor;
    const decimalRoundBehavior = this.decimalRoundBehavior.to(object);
    source["@decimal-place"] = decimalRoundBehavior.decimalPlace;
    source["@round"] = decimalRoundBehavior.round;
    const expressionBehavior = this.expressionBehavior.to(object);
    source.calculateitem = expressionBehavior.calculateitem;
    if (object.expressionKind === ExpressionKinds.Calculation) {
      this.relationReplacer.replaceBeans(
        source,
        "calculate",
        expressionBehavior.relation);
    }
  }

  private readonly numberStyle = new NumberStyleTranslator();
  private readonly numberRangeAlertBehavior = new NumberRangeAlertBehaviorTranslator();
  private readonly decimalRoundBehavior = new DecimalRoundBehaviorTranslator();
  private readonly expressionBehavior = new ExpressionBehaviorTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
